export { default } from './isMaxDate'
